import { useParams } from "react-router-dom";
import ExtendInvoice from "./extendInvoice";

export const ShowInvoice = () => {
  const { id } = useParams();

  return <ExtendInvoice row={{ id, onUpdate: () => {} }} />;
};
